/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {MWordsPipe as ɵa} from './words.pipe';